import { heightImg } from "assets/images";
import React, { useEffect, useState } from "react";
import "./OnboardingQuestions.scss";
import Question1 from "./section/Question1";
import Question2 from "./section/Question2";
import Question3 from "./section/Question3";
import Question4 from "./section/Question4";
import Question5 from "./section/Question5";
import { adddOrUpdateQuestionApi, questionListApi } from "services/question";
import useButtonLoader from "common/UseButtonLoader";
import { toastMessage } from "utils/toastMessage";
import Question6 from "./section/Question6";
const OnboardingQuestions = () => {
  const [activeTab, setActiveTab] = useState("Question-1");
  const [heightContent, setHeightContent] = useState({
    heightContentHeading: "",
    heightContent: [
      {
        range: "<5.2",
        title: "",
      },
      {
        range: "5.2-5.5",
        title: "",
      },
      {
        range: ">5.5",
        title: "",
      },
    ],
  });
  const [bodyShapeContent, setBodyShapeContent] = useState({
    bodyShapeContentHeading: "",
    bodyShapeContent: [
      {
        shape: "Round",
        title: "",
        description: "",
      },
      {
        shape: "Triangle",
        title: "",
        description: "",
      },
      {
        shape: "Hourglass",
        title: "",
        description: "",
      },
      {
        shape: "Rectangle",
        title: "",
        description: "",
      },
      {
        shape: "Inverted Triangle",
        title: "",
        description: "",
      },
    ],
  });
  const [styleIdentityContent, setStyleIdentityContent] = useState({
    styleIdentityContentHeading: "",
    styleIdentityContent: [
      {
        style: "",
        title: "",
        description: "",
      },
      {
        style: "",
        title: "",
        description: "",
      },
      {
        style: "",
        title: "",
        description: "",
      },
      {
        style: "",
        title: "",
        description: "",
      },
    ],
  });
  const [bodyFlauntContentHeading, setBodyFlauntContentHeading] = useState("");
  const [bodyDownContentHeading, setBodyDownContentHeading] = useState("");
  const [brandHeading, setBrandHeading] = useState("");

  const [preTextContent, setPreTextContent] = useState({
    startDate: "",
    endDate: "",
    image: "",
  });

  const fetchContent = async () => {
    try {
      const res = await questionListApi();
      console.log(res, "response");
      if (res.data.status === 200) {
        setHeightContent({
          heightContentHeading:
            res.data.data?.onboardingContent?.heightContentHeading,
          heightContent: res.data.data.onboardingContent?.heightContent,
        });
        setBodyShapeContent({
          bodyShapeContentHeading:
            res.data.data.onboardingContent?.bodyShapeContentHeading,
          bodyShapeContent: res.data.data.onboardingContent?.bodyShapeContent,
        });
        setStyleIdentityContent({
          styleIdentityContentHeading:
            res.data.data.onboardingContent?.styleIdentityContentHeading,
          styleIdentityContent:
            res.data.data.onboardingContent?.styleIdentityContent,
        });
        setBodyFlauntContentHeading(
          res.data.data.onboardingContent?.bodyFlauntContentHeading
        );
        setBodyDownContentHeading(
          res.data.data.onboardingContent?.bodyDownContentHeading
        );
        setBrandHeading(res.data.data.onboardingContent?.brandHeading);
        setPreTextContent({
          startDate: res.data?.data?.onboardingContent?.popupStartDate || "",
          endDate: res.data?.data?.onboardingContent?.popupEndDate || "",
          image: res.data?.data?.onboardingContent?.loginPopupImage || "",
        });
      } else {
        toastMessage(res.data.message, "error", "contentFetch");
      }
    } catch (error) {
      console.error("Error fetching content:", error.message);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);
  const [errors, setErrors] = useState({});
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Save");
  const validation = () => {
    let isValid = true;
    const error = {};

    // Validate heightContent
    if (!heightContent.heightContentHeading) {
      error["heightContentHeading"] =
        "Please enter a heading for height content";
      isValid = false;
    }
    heightContent.heightContent.forEach((item, index) => {
      if (!item.title) {
        error[
          `heightContentTitle${index}`
        ] = `Please enter a title for range: ${item.range}`;
        isValid = false;
      }
    });

    // Validate bodyShapeContent
    if (!bodyShapeContent.bodyShapeContentHeading) {
      error["bodyShapeContentHeading"] =
        "Please enter a heading for body shape content";
      isValid = false;
    }
    bodyShapeContent.bodyShapeContent.forEach((item, index) => {
      if (!item.title) {
        error[
          `bodyShapeContentTitle${index}`
        ] = `Please enter a title for shape: ${item.shape}`;
        isValid = false;
      }
      if (!item.description) {
        error[
          `bodyShapeContentDescription${index}`
        ] = `Please enter a description for shape: ${item.shape}`;
        isValid = false;
      }
    });

    // Validate styleIdentityContent
    if (!styleIdentityContent.styleIdentityContentHeading) {
      error["styleIdentityContentHeading"] =
        "Please enter a heading for style identity content";
      isValid = false;
    }
    styleIdentityContent.styleIdentityContent.forEach((item, index) => {
      if (!item.style) {
        error[
          `styleIdentityContentStyle${index}`
        ] = `Please enter a style for styleIdentityContent at position ${
          index + 1
        }`;
        isValid = false;
      }
      if (!item.title) {
        error[
          `styleIdentityContentTitle${index}`
        ] = `Please enter a title for styleIdentityContent at position ${
          index + 1
        }`;
        isValid = false;
      }
      if (!item.description) {
        error[
          `styleIdentityContentDescription${index}`
        ] = `Please enter a description for styleIdentityContent at position ${
          index + 1
        }`;
        isValid = false;
      }
    });
    // Validate bodyFlauntContentHeading and bodyDownContentHeading
    if (!bodyFlauntContentHeading) {
      error["bodyFlauntContentHeading"] =
        "Please enter a heading for body flaunt content";
      isValid = false;
    }
    if (!bodyDownContentHeading) {
      error["bodyDownContentHeading"] =
        "Please enter a heading for body down content";
      isValid = false;
    }
    // Validate brandHeading
    if (!brandHeading) {
      error["brandHeading"] = "Please enter a brand heading";
      isValid = false;
    }

    if (!preTextContent.startDate) {
      error["startDate"] = "Please enter Start Date";
      isValid = false;
    }
    if (!preTextContent.endDate) {
      error["endDate"] = "Please enter End Date";
      isValid = false;
    }

    // Validate bodyShapeContent
    if (!preTextContent.image) {
      error["image"] = "Please enter image";
      isValid = false;
    }
    setErrors(error);
    return isValid;
  };
  const addOrUpdateQuestion = async (e) => {
    console.log("heloo");
    e.preventDefault();
    if (validation()) {
      setButtonLoaders(true);
      try {
        const formData = {
          heightContent: JSON.stringify(heightContent.heightContent),
          bodyShapeContent: JSON.stringify(bodyShapeContent.bodyShapeContent),
          styleIdentityContent: JSON.stringify(
            styleIdentityContent.styleIdentityContent
          ),
          heightContentHeading: heightContent.heightContentHeading,
          bodyShapeContentHeading: bodyShapeContent.bodyShapeContentHeading,
          styleIdentityContentHeading:
            styleIdentityContent.styleIdentityContentHeading,
        };
        const res = await adddOrUpdateQuestionApi(formData);
        if (res?.data?.status === 200) {
          toastMessage(res?.data?.message, "success", "addBrand");
        } else {
          toastMessage(res?.data?.message, "error", "addBrand");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoaders(false);
      }
    }
  };
  return (
    <>
      <div className="onboarding_question">
        <div className="card top_card">
          <div className="dashboard_title">
            <h3>Onboarding Questions</h3>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="tab_button_wrap">
              <ul>
                <li>
                  <button
                    type="button"
                    onClick={() => setActiveTab("Question-1")}
                    className={activeTab === "Question-1" ? "active" : ""}
                  >
                    Question-1
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "Question-2" ? "active" : ""}
                    onClick={() => setActiveTab("Question-2")}
                  >
                    Question-2
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "Question-3" ? "active" : ""}
                    onClick={() => setActiveTab("Question-3")}
                  >
                    Question-3
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "Question-4" ? "active" : ""}
                    onClick={() => setActiveTab("Question-4")}
                  >
                    Question-4
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "Question-5" ? "active" : ""}
                    onClick={() => setActiveTab("Question-5")}
                  >
                    Brands
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "Question-6" ? "active" : ""}
                    onClick={() => setActiveTab("Question-6")}
                  >
                    Pre-login Text
                  </button>
                </li>
              </ul>
            </div>
            <div className="tab_content">
              {activeTab === "Question-1" && (
                <Question1
                  setHeightContent={setHeightContent}
                  buttonLoaders={buttonLoaders}
                  errors={errors}
                  setErrors={setErrors}
                  heightContent={heightContent}
                  addOrUpdateQuestion={addOrUpdateQuestion}
                />
              )}
              {activeTab === "Question-2" && (
                <Question2
                  bodyShapeContent={bodyShapeContent}
                  buttonLoaders={buttonLoaders}
                  errors={errors}
                  setErrors={setErrors}
                  setBodyShapeContent={setBodyShapeContent}
                  addOrUpdateQuestion={addOrUpdateQuestion}
                />
              )}
              {activeTab === "Question-3" && (
                <Question3
                  setStyleIdentityContent={setStyleIdentityContent}
                  buttonLoaders={buttonLoaders}
                  errors={errors}
                  setErrors={setErrors}
                  styleIdentityContent={styleIdentityContent}
                  addOrUpdateQuestion={addOrUpdateQuestion}
                />
              )}
              {activeTab === "Question-4" && (
                <Question4
                  bodyDownContentHeading={bodyDownContentHeading}
                  buttonLoaders={buttonLoaders}
                  errors={errors}
                  setErrors={setErrors}
                  setBodyDownContentHeading={setBodyDownContentHeading}
                  bodyFlauntContentHeading={bodyFlauntContentHeading}
                  setBodyFlauntContentHeading={setBodyFlauntContentHeading}
                  addOrUpdateQuestion={addOrUpdateQuestion}
                />
              )}
              {activeTab === "Question-5" && (
                <Question5
                  brandHeading={brandHeading}
                  buttonLoaders={buttonLoaders}
                  errors={errors}
                  setErrors={setErrors}
                  setBrandHeading={setBrandHeading}
                  addOrUpdateQuestion={addOrUpdateQuestion}
                />
              )}
              {activeTab === "Question-6" && (
                <Question6
                  preTextContent={preTextContent}
                  setPreTextContent={setPreTextContent}
                  errors={errors}
                  validation={validation}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default OnboardingQuestions;
